export default __webpack_public_path__ + "static/media/es.1d90be0c.jpg";